import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StepperNavigationHelperService {
  private readonly goToStep$ = new Subject<number>();
  private readonly disabledGoToStep$ = new BehaviorSubject<boolean>(false);
  private readonly finalize$ = new Subject<boolean>();

  constructor() {}

  getGoToStep() {
    return this.goToStep$ as Observable<number>;
  }

  emitGoToStep(stepIndex: number) {
    this.goToStep$.next(stepIndex);
  }

  getDisableGoToStep() {
    return this.disabledGoToStep$ as Observable<boolean>;
  }

  emitDisableGoToStep(disable: boolean) {
    this.disabledGoToStep$.next(disable);
  }

  getFinalize() {
    return this.finalize$ as Observable<boolean>;
  }

  emitFinalize(emit: boolean) {
    this.finalize$.next(emit);
  }
}
